import { Plugin } from 'ckeditor5';

export default class TableExtended extends Plugin {
	init() {
		const editor = this.editor;
		editor.conversion.attributeToAttribute({
			model: 'class',
			view: 'class',
		});

    // add listener to add classes to table, rows and columns
    editor.conversion.for('downcast').add(dispatcher => {
			dispatcher.on('insert:table', (evt, data, conversionApi) => {
        this.downcastConverter(data, conversionApi);
      });
    });
	}

  downcastConverter({ item }, conversionApi) {
    const viewWriter = conversionApi.writer;
    const tableRows = item._children;
    const tableViewElement = conversionApi.mapper.toViewElement(item);

    const generalRowCount = this.getGeneralRowCount(item);
    const generalColCount = this.getGeneralColCount(item);

    const tableClasses = [
      `rows_total_${generalRowCount}`,
      `cols_total_${generalColCount}`,
      ...tableViewElement.getClassNames()
    ];
    viewWriter.setAttribute('class', tableClasses.join(' '), tableViewElement);

    const totalRowClassName = `total_row_${tableRows._nodes.length}`
    let rowCount = 0;
    for (let row of tableRows) {
      rowCount++;
      const rowClassName = `row_${rowCount}`;
      const oddEvenClassName = rowCount % 2 ? 'odd' : 'even';
      const tableRowViewElement = conversionApi.mapper.toViewElement(row);

      const rowClasses = [
        rowClassName,
        totalRowClassName,
        oddEvenClassName,
        ...tableRowViewElement.getClassNames()
      ];
      viewWriter.setAttribute('class', rowClasses.join(' '), tableRowViewElement);

      const columns = row._children;
      let columnCount = 0;
      for (let column of columns) {
        columnCount++;

        const tableRowColumnViewElement = conversionApi.mapper.toViewElement(column);

        const oddEvenClassName = columnCount % 2 ? 'odd' : 'even';
        const columnClasses = [
          `col_${columnCount}`,
          `total_row_${columns.length}`, // TODO: maybe "total_col_ ..." ?
          oddEvenClassName,
          ...tableRowColumnViewElement.getClassNames(),
        ];
        viewWriter.setAttribute('class', columnClasses.join(' '), tableRowColumnViewElement);
      }
    }
  }

	getGeneralRowCount({ _children }) {
    return [..._children].length;
	}

	getGeneralColCount({ _children: rows }) {
		let maxCount = 0;

		for (let { _children: cols } of rows) {
			const colCount = [...cols].length;
      maxCount = Math.max(maxCount, colCount);
		}

		return maxCount;
	}
}
